import { useEffect } from 'react'

import { isConsole } from '../../config/config'

interface PageTitleProps {
  title: string
}

const BASE_TITLE = 'CloudTrucks'

export function PageTitle({ title }: PageTitleProps) {
  usePageTitle(title)
  return null
}

export function usePageTitle(title: string) {
  useEffect(() => {
    if (!title) return

    if (isConsole()) document.title = title || BASE_TITLE
    else document.title = `${title} | ${BASE_TITLE}` || BASE_TITLE

    return () => {
      document.title = BASE_TITLE
    }
  }, [title])
}
